import React from 'react';
import CriterionForm from "./criterionForm";
import Paper from "@material-ui/core/Paper";
import { withStyles } from '@material-ui/core/styles';
import Loading from "../loading/loading";
import Snackbar from '@material-ui/core/Snackbar';

const styles = theme => ({
  root: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: theme.spacing.unit * 3,
  }),
  paper: {
    position: 'absolute',
    width: theme.spacing.unit * 50,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 4,
  },
  button: {
    margin: theme.spacing.unit,
  },
  list: {
    maxHeight: 50 * 2,
    overflowY: 'auto'
  },

});

const Criterion =  (props) =>{
  const { classes, criterion, loading } = props;

  return (
    <Paper className={classes.root} elevation={4}>
      <Loading displayLoader={loading}/>
      <div className={'row'}>
        <div className={'col-12 col-lg-4'}>
          <CriterionForm {...props} initialValues={criterion} handleCancel={props.history.goBack}/>
        </div>
      </div>
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={!!props.message}
        onClose={() => { props.changeCriterionState({key: 'message', value: ''}) }}
        ContentProps={{'aria-describedby': 'message-id',}}
        message={<span id="message-id">{props.message}</span>}
      />
    </Paper>
  )

};

export default withStyles(styles)(Criterion);



// WEBPACK FOOTER //
// ./src/components/criterion/criterion.js